import { userHasConsentedToCookieCategoryWithKey } from 'src/cookies/consent-cookie';

export const analyticsConsentCookieCategoryKey = 'analytics';

export const userHasConsentedToAnalyticsCookieCategory = (): boolean =>
  userHasConsentedToCookieCategoryWithKey(analyticsConsentCookieCategoryKey);
